import React,{useEffect, useLayoutEffect, useRef, useState} from 'react'

import { EffectComposer, SSAO } from "@react-three/postprocessing";
import { BlendFunction } from "postprocessing";

import { OrbitControls,  Environment, ContactShadows ,Html} from '@react-three/drei'
import { Canvas, useFrame,  useThree } from "@react-three/fiber";
import {  useSpring, animated } from '@react-spring/web'


import { Suspense } from "react";
import * as THREE from "three";
import Model from "components/Model/model.jsx";


import './index.css'
import App  from './App'

import AppProvider ,{CanvasProvider,useCanvas} from 'store/AppStore'

import { createRoot } from 'react-dom/client';

import useAnalyticsEventTracker from './lib/useAnalyticsEventTracker';



const tempObject = new THREE.Object3D()


const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript


const CameraController = (props) => {
 
  const { CanvasState,seqId,setTouchMode } = useCanvas();
  const ocRef = useRef(null)
  const cameraRef = useRef()

  const [rotateS, setRotateSpeed ] = useState(0.004);
  const [isMoving, setIsMoving] = useState(false);
  const timeoutIdRef = useRef(null);

  //let camera = useThree((state) => state.camera)
  const set = useThree(state => state.set)
  const size = useThree(({ size }) => size)

  useLayoutEffect(() => {
    //console.log("SET_CAMERA")
    set({ camera: cameraRef.current })
  }, [])

    
  useLayoutEffect(() => {
    if (cameraRef.current) {
      cameraRef.current.aspect = size.width / size.height
      //console.log("UPDATE_CAMERA")
      cameraRef.current.updateProjectionMatrix()
    }
  }, [size, props])

  //let camera = useThree()
  //const cameraRef = useRef(null)
  const targetRefX = useRef()
  const targetRefY = useRef()
  //const camera =cameraRef.current
  const deg2rad = degrees => degrees * (Math.PI / 180);

  useEffect(() => {
    setTouchMode(window.utalk.touchenabled);
    if ( ocRef.current && cameraRef.current && targetRefX.current && targetRefY.current && CanvasState) {
      //cameraRef.current.updateProjectionMatrix()
      let p = cameraRef.current.position.clone()
      let r = cameraRef.current.rotation.clone()
      if (window.utalk.touchenabled) {
      //if (props.controlStyle == "orbit") {
        ocRef.current.target.set(0, 6, 0)
        cameraRef.current.position.set(-6, 8, 18)
        targetRefX.current.position.set(0,0,0)
        targetRefX.current.rotation.set(0,0,0)
        targetRefX.current.updateMatrixWorld()
        targetRefY.current.rotation.set(0,0,0)
        targetRefY.current.updateMatrixWorld()
      }
      if (!window.utalk.touchenabled) {
      //if (props.controlStyle !== "orbit") {
        ocRef.current.reset()
        targetRefX.current.position.set(0,6.5,0)
        targetRefX.current.rotation.set(0,deg2rad(-45),0)
        targetRefX.current.updateMatrixWorld()
        targetRefY.current.rotation.set(deg2rad(-5),0,0)
        targetRefY.current.updateMatrixWorld()
        cameraRef.current.rotation.set(0,0,0)
        cameraRef.current.position.set(0, 0, 21)
        cameraRef.current.updateMatrixWorld()
        
      }
      

      tempObject.rotation.y = targetRefX.current.rotation.y
      tempObject.rotation.x = targetRefY.current.rotation.x
 
    }
  }, [ cameraRef.current,CanvasState])

  function map(val, in_min, in_max, out_min, out_max) {
    return (val - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
  }

  function lerp (start, end, amt){
    return (1-amt)*start+amt*end
  }

  useFrame((state, delta) => {
     if ( (window.utalk.aosX >= 0 - Math.Epsilon && window.utalk.aosX <= 0.0 + Math.Epsilon) ==0 && (window.utalk.aosY >= 0.0 - Math.Epsilon && window.utalk.aosY <= 0.0 + Math.Epsilon) || window.utalk.touchenabled ){
    targetRefX.current.rotation.y -= rotateS;
     }
    //targetRefZ.current.rotation.x -= 0.008; monter descendre
    // cameraRef.current.position.z  // le zoom
    //camera.updateProjectionMatrix();
    //cameraRef.current.updateProjectionMatrix()
    if (!window.utalk.touchenabled) {

      tempObject.rotation.y = (window.utalk.aosX >= 0 - Math.Epsilon && window.utalk.aosX <= 0.0 + Math.Epsilon) ? tempObject.rotation.y : tempObject.rotation.y + (window.utalk.aosX * 4);
      tempObject.rotation.x = (window.utalk.aosY >= 0.0 - Math.Epsilon && window.utalk.aosY <= 0.0 + Math.Epsilon) ? tempObject.rotation.x : tempObject.rotation.x + (window.utalk.aosY * 4);

    targetRefX.current.rotation.y = lerp (targetRefX.current.rotation.y, tempObject.rotation.y , delta* 3);
    targetRefY.current.rotation.x = lerp (targetRefY.current.rotation.x, tempObject.rotation.x , delta* 3);
    //targetRefX.current.rotation.y += window.utalk.aosX
    //targetRefY.current.rotation.x += window.utalk.aosY
    cameraRef.current.position.z = lerp (cameraRef.current.position.z, map(window.utalk.aosZ,0,100,60,12), delta * 3);
    
    }
    handleStartMoveForAOS();
  });


// CHANGE automatique Rotation to zero for 5 second when start moving

function handleStartMoveForAOS() {
  if (window.utalk.touchenabled) return;
  if (isMoving) return;
  setIsMoving(true);
  setRotateSpeed(0);
   clearTimeout(timeoutIdRef.current);
  timeoutIdRef.current = setTimeout(() => {
    setRotateSpeed(0.004);
    setIsMoving(false);
  }, 7000);
}


  function handleStartMoveForOrbitControl() {
    setRotateSpeed(0);
     clearTimeout(timeoutIdRef.current);
    timeoutIdRef.current = setTimeout(() => {
      setRotateSpeed(0.004);
      
    }, 7000);
  }

  // on pause quand on utilise le boutton play
  useEffect(()=>{
    handleStartMoveForOrbitControl() ;
  },[seqId])

  // position={[-6, 8, 18]}
  //<axesHelper args={[8]} />
  return (
    <>
     <group position={[0,0,0]}ref={targetRefX}>
     
       <group position={[0,0,0]} ref={targetRefY}>
    
          <perspectiveCamera
            ref={cameraRef}
            position={[0, 0, 18]}
            makeDefault
            args={[45, 1.0, 1, 1000]}
              ></perspectiveCamera>
     </group>
    </group>
    
    <OrbitControls  onStart={() => {
        handleStartMoveForOrbitControl();
        //setRotateSpeed(0);
      }}
     enabled={window.utalk.touchenabled} target={[0, 6, 0]} ref={ocRef} rotateSpeed={2} enablePan={false} maxDistance={60} minDistance={12} />
    </>
  )
}






//<OrbitControls enabled={props.controlStyle === 'orbit'} target={[0, 6, 0]} ref={ocRef} rotateSpeed={2} />
//<OrbitControls enabled={window.utalk.touchenabled} target={[0, 6, 0]} ref={ocRef} rotateSpeed={2} />

const Orbitthree = React.memo( () => {
  const { CanvasState, setCanvasState } = useCanvas();
  const [delay,setDelay] = useState(false) 
  const modelRef = useRef()
  //console.log("SHOWCANVAS",CanvasState) 

  /*
  const [controlStyle, setControlStyle] = useState('trackball')
  const toggleControlStyle = () => {
    if (controlStyle === 'orbit') setControlStyle('trackball')
    else setControlStyle('orbit')
  }
*/
  /*
  useEffect(() => {
    camera.position.set(0, 0, 200)}, 
    [CanvasState]  )
  
  */
    useEffect(() => {
      if (delay == false){
      setTimeout(() => {
        setDelay(true)
      },2300);
    }
    }, []);



    const fade = useSpring({
    opacity: CanvasState ? 1: 0,
    left: CanvasState ? "0%": "120%",
    position: "absolute",
    width:"100%",
    height:"100%",
    top:"0",
  })

  const fade2 = {
    left: 0,
    position: "absolute",
    width:"100%",
    height:"100%",
    top:"0",
    overflow:"hidden",
  
  }

  /*
  const [objects, setObjects] = useState([]);

  useEffect(() => {
    const checkIfModelIsLoaded = () => {
      if (modelRef.current) {
        setObjects(modelRef.current.children);
        console.log('--------------------------------------yes');
        console.log(modelRef.current.children[0]);
        const o = modelRef.current.children[0];

      } else {
        requestAnimationFrame(checkIfModelIsLoaded);
      }
    };
    checkIfModelIsLoaded();
  }, [modelRef]);

  */

 //camera={{ fov: 45, position: [-6, 8, 18] }}
 //<OrbitControls ref={orbitCtrl} target={[0, 6, 0]} />
 /*
 
      <button style={{ position: 'absolute', top: '1rem', left: '0.5rem', zIndex:1000 }} onClick={toggleControlStyle}>Change camera controller</button>
      <div style={{ position: 'absolute', top: '2rem', left: '0.5rem' }}>{controlStyle}</div>


Ajouter une etiquette  Test..
-.---------------------
<group position={[-1.5, 7.2, 1.6]} rotation={[0,0,0]}>
  <Marker rotation={[0, 0, 0]}>
   <div style={{ position: 'absolute', fontSize: 20, letterSpacing: -0.5, left: 0 }}>Led </div> 
  </Marker>
</group>

...
      
  */




  return (
    <div style={fade2}>
      
    <animated.div style={fade}>
    <Canvas onLoad={() => {} } shadows className="displayedThree" >
    <Suspense fallback={null}>
    <fog attach="fog" color="white" near={50} far={75} />
     <Environment files="3D/city.hdr" />
    {false && <EffectsMemo/>}
     <directionalLight castShadow
      shadow-bias={-0.0005}
      shadow-camera-far={65}
      shadow-camera-left={-20}
      shadow-camera-right={20}
      shadow-camera-top={20}
      shadow-camera-bottom={-20}
  shadow-mapSize-height={4096}
  shadow-mapSize-width={4096} intensity={0.5} position={[5, 10, 50]} />

<directionalLight  intensity={.15} position={[-25, 0, -10]} />

{ delay ?<CameraController ></CameraController>: null }
       <ContactShadows scale={20} position={[0, -1, 0]} far={20} blur={5} opacity={0.6} color="#204060" />
       <ContactShadows scale={30} rotation={[90,0,0]} position={[0,0, 5]} far={20} blur={5} opacity={1} color="#000" />
      
      { delay ? <Model path="3D/VOYAGER_HOLDER_V2c.glb" groupRef={modelRef} scale={new Array(3).fill(0.005)} reset={CanvasState} /> : null }
</Suspense>
    </Canvas>
  </animated.div>
  </div>
    
  )
 

 
})


//<Effects />
// Ne marche pas avec la nouvelle version il y a un bug d'affichage 
function Effects() {
  return (
    <EffectComposer disableNormalPass autoClear={1} >
      <SSAO
        blendFunction={BlendFunction.MULTIPLY} // Use NORMAL to see the effect
        samples={50}
        radius={.08}
        intensity={27}
      />
    </EffectComposer>
  );
}

// WARNING EffectComposer Create a big memory leak
// put on memo fix the issue.
export const EffectsMemo = React.memo(Effects);

//console.log(container)
root.render(
  <CanvasProvider>
  <AppProvider>
    <App />
  </AppProvider>
  <Orbitthree></Orbitthree>
  </CanvasProvider>
);

/*
ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>,
  document.getElementById('root')
)
*/